import styled from "styled-components";

import { MOBILE_BREAKPOINT } from "features/MenuEditor/styles";

export const Filters = styled.div`
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 10px;
    margin-bottom: 20px;
`;

export const Search = styled.div`
    flex: 0 1 300px;
    min-width: 200px;

    @media (max-width: ${MOBILE_BREAKPOINT - 1}px) {
        flex: 1 1 100%;
    }
`;

export const Chips = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    flex: 0 1 auto;
    min-width: 0;

    @media (max-width: ${MOBILE_BREAKPOINT - 1}px) {
        /* Лента чипов прокручивается сама — кнопка порядка рядом остаётся на месте,
           иначе она уезжала бы за экран вместе с фильтрами. */
        overflow-x: auto;
        flex-wrap: nowrap;
        padding-bottom: 4px;
        -webkit-overflow-scrolling: touch;
    }
`;
